<script lang="ts">
	import { DataHandlerDevice, Tag, type Device, DataHandlerTag } from "luxedo-data"
	import { UserStore } from "../../../../../stores/UserStore.svelte"
	import ProjectTags from "../../../tags/ProjectTags.svelte"
	import { Responsive } from "responsive"

	interface Props {
		name?: string
		description?: string
		selectedDeviceId: number
		selectedTags: Array<number>
		triggerCreate: () => void
	}

	let {
		name = $bindable(),
		description = $bindable(),
		selectedDeviceId = $bindable(),
		selectedTags = $bindable(),
		triggerCreate,
	}: Props = $props()

	name = "Enter scene title..."
	selectedTags = []

	let isMobile = $derived(Responsive.isMobile)

	let tags: Array<Tag> = DataHandlerTag.getMany()
	DataHandlerTag.addListener(() => {
		tags = [...DataHandlerTag.getMany()]
	})

	let availableDevices: Array<Device> = $state()
	UserStore.subscribe(() => {
		availableDevices = DataHandlerDevice.getMany()
	})

	function onSceneNameChange(
		e: KeyboardEvent & {
			currentTarget: EventTarget & HTMLHeadingElement
		}
	) {
		if (e.key === "Enter") {
			e.preventDefault()
			return triggerCreate()
		}
		const target = e.currentTarget
		setTimeout(() => {
			name = target.innerText
		})
	}

	function handleTouch(
		e: TouchEvent & {
			currentTarget: HTMLHeadingElement
		}
	) {
		const target = e.currentTarget
		e.currentTarget.focus()

		requestAnimationFrame(() => {
			const range = document.createRange()
			range.selectNodeContents(target)
			const selection = window.getSelection()
			selection.removeAllRanges()
			selection.addRange(range)
		})
	}
</script>

<div class="scene-inputs" class:isMobile>
	<h1
		id="new-scene-title-input"
		onkeydown={onSceneNameChange}
		ontouchend={handleTouch}
		contenteditable={true}
	>
		Enter scene title...
	</h1>
	<div class="scene-inputs-bottom-row">
		<div class="left">
			<div class="tag-container">
				<ProjectTags bind:selectedTags isLibraryContext={false} />
			</div>
		</div>
		<div class="select-container">
			<label for="scene-projector-input">Select Projector:</label>
			<select id="scene-projector-input" bind:value={selectedDeviceId}>
				{#each availableDevices as device}
					<option value={device.id}>{device.name}</option>
				{/each}
			</select>
		</div>
	</div>
</div>

<style>
	h1 {
		font-size: var(--text-h2);
		margin: 0;
	}

	.scene-inputs {
		height: fit-content;
		padding: 6rem 2rem 2rem 2rem;

		width: 100%;
		background-color: var(--color-bg-dark);
	}

	.tag-container {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}

	.scene-inputs-bottom-row {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-end;
	}

	.left {
		width: 70%;
	}

	.select-container {
		flex-direction: column;
		align-items: flex-start;
		align-self: center;
	}

	.select-container label {
		padding-left: 0.25rem;
		color: var(--color-text);
	}

	.select-container select {
		padding: 0;
		color: var(--color-text-light);
	}

	.select-container option {
		color: var(--color-text-light);
	}

	.isMobile.scene-inputs {
		padding: 3rem 1rem 1rem 1rem;
	}

	.isMobile.scene-inputs h1 {
		font-size: var(--text-h4);
	}

	.isMobile .scene-inputs-bottom-row {
		flex-direction: column-reverse;
		align-items: flex-start;
		gap: 0.5rem;
	}

	.isMobile .left {
		width: 100%;
	}

	.isMobile .select-container {
		align-self: flex-start;
	}

	.isMobile .select-container label {
		padding-left: 0;
	}

	.isMobile .select-container select {
		margin-left: -0.2rem;
	}
</style>
